import { defineStore } from 'pinia'

export const useChannelsStore = defineStore('channels', {
    state: () => ({
        channels: [],
    }),
    actions: {
        setChannels(channels) {
            this.channels = channels
        },
    },
})
